import React, {Component} from 'react';
import axios from 'axios';
import Select from 'react-select';
import ConditionalBlock from "./ConditionalBlock";

export default class SupplierDetailsForm extends Component {
    constructor() {
        super();

        this.state = {
            tax_offices: [],

            supplier_id: 0,
            supplier_company_name: "",
            supplier_representative: "",
            supplier_vat_number: "",
            supplier_tax_office_id: "",
            supplier_address: "",
            supplier_phone: "",

        };

        this.formChange = this.formChange.bind(this);
        this.handleSupplierChange = this.handleSupplierChange.bind(this);
        this.handleTaxOfficeChange = this.handleTaxOfficeChange.bind(this);
    }

    componentWillMount() {
        let tax_offices = window.tax_offices;
        let supplier = this.props.supplier;

        this.setState({
            tax_offices: tax_offices,

            supplier_id: supplier.id,
            supplier_company_name: supplier.company_name,
            supplier_representative: supplier.representative,
            supplier_vat_number: supplier.vat_number,
            supplier_tax_office_id: supplier.tax_office_id,
            supplier_address: supplier.address,
            supplier_phone: supplier.phone,
        });
    }

    formChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getSuppliers(input) {
        if (!input) {
            return Promise.resolve({options: []});
        }

        return axios("/contracts/ajax/suppliers/search/" + input)
            .then((response) => {
                return {options: response.data};
            });
    }

    handleSupplierChange(value) {
        let supplier_id = 0;
        if (value !== null)
            supplier_id = value.value;

        // Autofill supplier details
        this.setState({
            supplier_id: supplier_id
        }, () => {
            if (supplier_id !== 0) {
                axios
                    .get("/contracts/ajax/suppliers/" + supplier_id)
                    .then((response) => {
                        let data = response.data;
                        this.setState({
                            supplier_company_name: data.company_name,
                            supplier_vat_number: data.vat_number,
                            supplier_tax_office_id: data.tax_office_id,
                            supplier_address: data.address,
                            supplier_phone: data.phone1
                        });
                    });
            }
        });
    }

    handleTaxOfficeChange(e) {
        let tax_office_id = "";
        if (e !== null)
            tax_office_id = e.value;
        this.setState({
            supplier_tax_office_id: tax_office_id
        });
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-offset-4 col-sm-8">
                        <legend>{window.__js_general.supplier_data}</legend>
                    </div>
                </div>

                <ConditionalBlock show={window._has_competitions_permission}>
                    <div className="form-group">
                        <label htmlFor="supplier_id" className="control-label col-md-4">
                            {window.__js_general.insert_existing_supplier_data}
                        </label>
                        <div className="col-md-8">
                            <Select.Async id="supplier_id"
                                          value={this.state.supplier_id}
                                          onChange={this.handleSupplierChange}
                                          loadOptions={this.getSuppliers}/>
                            <span className="help-block">
                            {window.__js_general.find_supplier_by}
                        </span>
                        </div>
                    </div>
                </ConditionalBlock>

                <div className="form-group">
                    <label htmlFor="supplier_company_name" className="control-label col-md-4">
                        {window.__js_general.company_name}*
                    </label>
                    <div className="col-md-8">
                        <input type="text"
                               id="supplier_company_name"
                               name="supplier_company_name"
                               value={this.state.supplier_company_name}
                               className="form-control"
                               onChange={this.formChange}/>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="supplier_representative" className="control-label col-md-4">
                        {window.__js_general.representative}
                    </label>
                    <div className="col-md-8">
                        <input type="text"
                               id="supplier_representative"
                               name="supplier_representative"
                               value={this.state.supplier_representative}
                               className="form-control"
                               onChange={this.formChange}/>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="supplier_vat_number" className="control-label col-md-4">
                        {window.__js_dashboard.supplier_vat_number}*
                    </label>
                    <div className="col-md-8">
                        <input type="text"
                               id="supplier_vat_number"
                               name="supplier_vat_number"
                               value={this.state.supplier_vat_number}
                               className="form-control"
                               onChange={this.formChange}/>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="supplier_tax_office_id" className="control-label col-md-4">
                        {window.__js_general.tax_office}
                    </label>
                    <div className="col-md-8">
                        <Select
                            id="supplier_tax_office_id"
                            name="supplier_tax_office_id"
                            value={this.state.supplier_tax_office_id}
                            options={this.state.tax_offices}
                            onChange={this.handleTaxOfficeChange}/>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="supplier_address" className="control-label col-md-4">
                        {window.__js_general.address}
                    </label>
                    <div className="col-md-8">
                        <input type="text"
                               id="supplier_address"
                               name="supplier_address"
                               value={this.state.supplier_address}
                               className="form-control"
                               onChange={this.formChange}/>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="supplier_phone" className="control-label col-md-4">
                        {window.__js_general.phone}
                    </label>
                    <div className="col-md-8">
                        <input type="text"
                               id="supplier_phone"
                               name="supplier_phone"
                               value={this.state.supplier_phone}
                               className="form-control"
                               onChange={this.formChange}/>
                    </div>
                </div>
            </div>
        );
    }
}